import { CACHE_TIME, STALE_TIME } from '@/constants';
import { trpc } from '@/data-loaders';

export const useEmpStatusAbbrList = (schoolId: number) => {
  return trpc.schoolUnit.getDistinctEmpStatusAbbrBySchoolIdList.useQuery(
    { schoolId },
    {
      retry: false,
      cacheTime: CACHE_TIME,
      staleTime: STALE_TIME,
      enabled: !!schoolId,
    },
  );
};
